<template>
  <div>
    <div>
      <div
        class="mb-2"
        v-if="['หัวข้อ', 'title', 'พารากราฟ'].includes(formdata.questiontype)"
      >
        <template v-if="['พารากราฟ'].includes(formdata.questiontype)">
          <Typography h5 semiBold :text="formdata.name" class="mb-1" />
        </template>
        <template v-if="['หัวข้อ', 'title'].includes(formdata.questiontype)">
          <Typography
            h5
            semiBold
            fontSize="fs28"
            :text="formdata.name"
            class="mb-1"
          />
          <v-divider></v-divider>
        </template>
      </div>
      <div v-else>
        <Typography h5 semiBold :text="formdata.name" class="mb-1" />
      </div>
      <ValidationProvider
        :name="formdata.name"
        :key="formdata.name"
        :rules="{
          required: formdata.isRequired,
        }"
        v-slot="{ errors }"
      >
        <div
          v-if="
            ['ข้อความ', 'กล่องข้อความ', 'คำตอบสั้นๆ'].includes(
              formdata.questiontype
            )
          "
        >
          <v-textarea
            :readonly="isReadonly"
            :disabled="isReadonly"
            :error-messages="errors"
            :value="value"
            @input="onInput"
            rows="1"
            outlined
            dense
          >
          </v-textarea>
        </div>
        <div v-else-if="formdata.questiontype == 'หลายตัวเลือก'">
          <v-radio-group
            :readonly="isReadonly"
            :disabled="isReadonly"
            :error-messages="errors"
            :value="value"
            @change="onInput"
          >
            <v-radio
              :key="k"
              :label="field.label"
              v-for="(field, k) in formdata.fields"
              :value="field.label"
            ></v-radio>
          </v-radio-group>
        </div>
        <div v-else-if="formdata.questiontype == 'เลื่อนลง'">
          <v-select
            :readonly="isReadonly"
            :disabled="isReadonly"
            :error-messages="errors"
            :value="value"
            outlined
            :item-text="'label'"
            dense
            @change="onInput"
            :items="formdata.fields"
          >
          </v-select>
        </div>
        <div
          v-else-if="formdata.questiontype == 'ช่องทำเครื่องหมาย'"
          class="mb-3"
        >
          <v-checkbox
            :readonly="isReadonly"
            :disabled="isReadonly"
            v-model="nativeSelectedItems"
            :value="field.label"
            @change="onInputArray"
            outlined
            hide-details
            dense
            :error-messages="errors"
            :label="field.label"
            :key="k"
            v-for="(field, k) in formdata.fields"
          >
          </v-checkbox>
          <div
            v-if="errors && errors.length"
            class="error--text v-messages v-messages__message mt-2"
          >
            กรุณาเลือกอย่างน้อย 1 ตัวเลือก
          </div>
        </div>

        <div v-else-if="formdata.questiontype == 'ตัวเลข'">
          <v-text-field
            outlined
            single-line
            dense
            v-model="valueData"
            @keypress="isNumber($event)"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :maxlength="formdata.digitPosition"
          ></v-text-field>
        </div>

        <div
          v-else-if="
            ['อัปโหลดเอกสาร', 'อัปโหลดไฟล์', 'อัปโหลดลายเซ็น'].includes(
              formdata.questiontype
            )
          "
        >
          <UploadDocument
            :errors="errors"
            @input="onInput"
            :value="value"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :multiple="formdata.isMultiple"
          ></UploadDocument>
          <template v-if="formdata.isMultiple">
            <div
              v-for="(item, index) in value"
              :key="index"
              style="width: 100%"
            >
              <div class="text-truncate">
                <span
                  style="font-weight: 900; color: #5da0c1; cursor: pointer"
                  @click="showItem(item)"
                >
                  {{ item | showFilename }}
                </span>
              </div>
            </div>
          </template>
          <template v-else>
            <div style="width: 100%">
              <div class="text-truncate">
                <span
                  style="font-weight: 900; color: #5da0c1; cursor: pointer"
                  @click="showItem(value)"
                >
                  {{ value | showFilename }}
                </span>
              </div>
            </div>
          </template>
        </div>
      </ValidationProvider>
    </div>

    <template v-if="formdata.questiontype == 'ที่อยู่'">
      <ValidationProvider
        :name="'บ้านเลขที่'"
        :key="'บ้านเลขที่'"
        :rules="{
          required: formdata.isRequired,
        }"
        v-slot="{ errors }"
      >
        <v-textarea
          :readonly="isReadonly"
          :disabled="isReadonly"
          :error-messages="errors"
          :value="address.addressno"
          @input="onInputAddress"
          rows="1"
          outlined
          dense
          placeholder="บ้านเลขที่"
        >
        </v-textarea>
      </ValidationProvider>
      <ValidationProvider
        :name="'ไปรษณีย์'"
        :key="'ไปรษณีย์'"
        :rules="{
          required: formdata.isRequired,
        }"
        v-slot="{ errors }"
      >
        <ThaiAddressInput
          v-model="address.zipcode"
          type="zipcode"
          @select="onSelectAddress"
          placeholder="ไปรษณีย์"
          data-vv-as="ไปรษณีย์"
          outline
          name="zipcode"
          light
          single-line
          :error-messages="errors"
        ></ThaiAddressInput>
      </ValidationProvider>
      <ValidationProvider
        :name="'จังหวัด'"
        :key="'จังหวัด'"
        :rules="{
          required: formdata.isRequired,
        }"
        v-slot="{ errors }"
      >
        <ThaiAddressInput
          v-model="address.province"
          type="province"
          @select="onSelectAddress"
          placeholder="จังหวัด"
          data-vv-as="จังหวัด"
          outline
          name="province"
          light
          :error-messages="errors"
        ></ThaiAddressInput>
      </ValidationProvider>
      <ValidationProvider
        :name="'เขต/อำเภอ'"
        :key="'เขต/อำเภอ'"
        :rules="{
          required: formdata.isRequired,
        }"
        v-slot="{ errors }"
      >
        <ThaiAddressInput
          v-model="address.amphoe"
          type="amphoe"
          @select="onSelectAddress"
          placeholder="เขต/อำเภอ"
          data-vv-as="เขต/อำเภอ"
          outline
          name="amphoe"
          light
          :error-messages="errors"
        ></ThaiAddressInput>
      </ValidationProvider>
      <ValidationProvider
        :name="'แขวง/ตำบล'"
        :key="'แขวง/ตำบล'"
        :rules="{
          required: formdata.isRequired,
        }"
        v-slot="{ errors }"
      >
        <ThaiAddressInput
          v-model="address.district"
          type="district"
          @select="onSelectAddress"
          placeholder="แขวง/ตำบล"
          data-vv-as="แขวง/ตำบล"
          outline
          name="district"
          light
          :error-messages="errors"
        ></ThaiAddressInput>
      </ValidationProvider>
    </template>
  </div>
</template>

<script>
import UploadDocument from "@/components/UploadDocument.vue";
import ThaiAddressInput from "@/components/ThaiAddressInput.vue";
export default {
  props: {
    value: {
      default: null,
    },
    errors: {
      default: null,
    },
    formdata: {
      default: null,
    },
    readonly: {
      default: false,
    },
  },
  components: {
    UploadDocument,
    ThaiAddressInput,
  },
  data() {
    return {
      nativeSelectedItems: this.value ? this.value : [],
    };
  },
  computed: {
    address: {
      get() {
        let val = {
          addressno: "",
          district: "",
          amphoe: "",
          province: "",
          zipcode: "",
        };
        if (this.value) {
          try {
            val = JSON.parse(this.value);
          } catch (error) {}
        }
        return val;
      },
      set(val) {
        this.$emit("input", JSON.stringify(val));
      },
    },
    isReadonly() {
      return this.query.mode == "readonly" || this.readonly;
    },
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onSelectAddress(address) {
      this.address = {
        ...this.address,
        ...address,
      };
    },
    showItem(item) {
      this.$liff.openWindow({
        url: item,
        external: true,
      });
    },
    onInput(e) {
      this.$emit("input", e);
    },
    onInputAddress(e) {
      this.address.addressno = e;
    },
    onInputArray(e) {
      this.$emit("input", this.nativeSelectedItems);
    },
  },
  filters: {
    showFilename(value) {
      var result = value && value[0] ? value[0] : value;

      if (result) {
        result = result.split("/");

        var newdata = result[4];
        result = newdata.substring(13);
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped></style>
